import type { PageMetaEntry } from './pageMeta';

export const PAGE_META_EN: Record<string, PageMetaEntry> = {
  home: {
    title: 'Luminary Business Solutions | ERP and Digital Transformation Consulting',
    description:
      'Logo certified solution partner and Logosoft solution partner. SAP B1, Logo ERP and digital transformation consulting.',
    ogImage: '/images/cta002.jpg',
  },
  cozumler: {
    title: 'Solutions | Luminary Business Solutions',
    description:
      'SAP B1, Logo ERP, DNAsoft, Boyum-IT, Computec, Coresystems solutions; Microsoft, security and infrastructure through Logosoft partnership.',
    ogImage: '/images/sap004.jpg',
  },
  cozumlerLogo: {
    title: 'Logo ERP | Luminary Business Solutions',
    description: 'Logo certified solution partner — Logo Tiger, Go and Start implementation, integration and support.',
    ogImage: '/images/logo004.jpg',
  },
  cozumlerLogosoft: {
    title: 'Logosoft | Luminary Business Solutions',
    description:
      'Logosoft corporate partner — consulting and implementation for Microsoft 365, Azure, Dynamics 365, security, infrastructure, AI, IoT and Huawei.',
    ogImage: '/images/logosoft002.jpg',
  },
  cozumlerLogosoftOrtakligi: {
    title: 'Logosoft | Luminary Business Solutions',
    description:
      'Logosoft corporate partner — consulting and implementation for Microsoft 365, Azure, Dynamics 365, security, infrastructure, AI, IoT and Huawei.',
    ogImage: '/images/logosoft002.jpg',
  },
  cozumlerSap: {
    title: 'SAP B1 | Luminary Business Solutions',
    description:
      'SAP Business One — real-time ERP, integrated business intelligence and flexible deployment. Luminary certified implementation, Boyum/Computec/Coresystems ecosystem and ProSoft integrations.',
    ogImage: '/images/sap004.jpg',
  },
  cozumlerBoyum: {
    title: 'Boyum-IT | Luminary Business Solutions',
    description:
      'SAP B1 add-ons: Beas Manufacturing, Produmex WMS, Perfion PIM, production scheduling, B1 Usability and more.',
    ogImage: '/images/boyum002.jpg',
  },
  cozumlerComputec: {
    title: 'Computec | Luminary Business Solutions',
    description:
      'CompuTec ProcessForce, PDC, WMS, Labels, AppEngine, WebUp and Holo — advanced SAP B1 manufacturing and logistics integration.',
    ogImage: '/images/computec002.jpg',
  },
  cozumlerCoresystems: {
    title: 'Coresystems | Luminary Business Solutions',
    description:
      'Coresystems FSM, InsightLoop, ChronoHub and Coresuite — Service AI and SAP Business One integrated service solutions.',
    ogImage: '/images/coresystems001.jpg',
  },
  cozumlerDnasoft: {
    title: 'DNAsoft | Luminary Business Solutions',
    description:
      'DNAsoft CAF apparel MRP and KAF profile/metal/sheet MRP. Two independent industry software products — which fits you?',
    ogImage: '/images/dnasoft001.jpg',
  },
  cozumlerDnasoftCaf: {
    title: 'DNAsoft CAF | Apparel MRP | Luminary',
    description:
      'CAF: ready-to-wear and apparel MRP. Color-size-length, assortment, cutting and boiler tracking with Logo Tiger integration.',
    ogImage: '/images/dnasoft001.jpg',
  },
  cozumlerDnasoftKaf: {
    title: 'DNAsoft KAF | Profile & Sheet MRP | Luminary',
    description:
      'KAF: aluminum, PVC, steel and sheet MRP. Kg-length-sheet conversion, RAL/anodized variants and Logo Tiger integration.',
    ogImage: '/images/dnasoft001.jpg',
  },
  cozumlerYapayZeka: {
    title: 'Artificial Intelligence | Luminary Business Solutions',
    description:
      'AI, automation and analytics on ERP data. Business goal consulting, capable implementation team and tailored solution design.',
    ogImage: '/images/probi/probi-dashboard-viewer.png',
  },
  hizmetler: {
    title: 'Services | Luminary Business Solutions',
    description: 'ERP consulting, implementation, support, training and custom software development.',
    ogImage: '/images/hizmetler-hero-v2.jpg',
  },
  urunler: {
    title: 'ProSoft Products | Luminary Business Solutions',
    description:
      'ProIntercompany and ProMES (SAP B1), ProMobile mobile WMS (SAP B1), ProBank (SAP B1 · Logo · Promax), ProBI and ProHR (platform independent) — the ProSoft product family.',
    ogImage: '/images/probi/probi-dashboard-viewer.png',
  },
  urunlerProintercompany: {
    title: 'ProIntercompany | SAP B1 Intercompany Integration',
    description: 'Intercompany integration and automated data transfer for SAP B1.',
    ogImage: '/images/prointer003.jpg',
  },
  urunlerProbi: {
    title: 'ProBI | Luminary Business Solutions',
    description:
      'Platform-independent business intelligence: Designer & Viewer, 18+ SQL sources, interactive data discovery and advanced analytics.',
    ogImage: '/images/probi/probi-dashboard-viewer.png',
  },
  urunlerProbank: {
    title: 'ProBank | Luminary Business Solutions',
    description: 'Bank reconciliation and automatic matching — integrated with SAP B1, Logo and Promax.',
    ogImage: '/images/probank-ui.png',
  },
  urunlerProhr: {
    title: 'ProHR | Luminary Business Solutions',
    description: 'Platform-independent HR, payroll and personnel management.',
    ogImage: '/images/prohr002.jpg',
  },
  urunlerPromes: {
    title: 'ProMES & IoT | Luminary Business Solutions',
    description: 'Production tracking, MES and IoT sensor integration with SAP B1.',
    ogImage: '/images/promes002.jpg',
  },
  urunlerPromobile: {
    title: 'ProMobile | Luminary Business Solutions',
    description:
      'Live SAP B1 mobile WMS — goods receipt, in-warehouse movement, smart shipping and bin location tracking.',
    ogImage: '/images/promobile002.jpg',
  },
  iletisim: {
    title: 'Contact | Luminary Business Solutions',
    description: 'Contact the Luminary team for project consulting and support.',
    ogImage: '/images/iletisim-hero-001.jpg',
  },
  destekIndir: {
    title: 'Download | Luminary Business Solutions',
    description: 'Download ProBI, ProBank, ProHR, ProMES and DNAsoft CAF/KAF packages directly.',
    ogImage: '/logo.png',
  },
  hakkimizda: {
    title: 'About Us | Luminary Business Solutions',
    description: 'ERP consulting since 2008. Luminary Software and Consulting — Istanbul.',
    ogImage: '/images/hakkimizda-hero-001.jpg',
  },
  notFound: {
    title: 'Page Not Found | Luminary Business Solutions',
    description: 'The page you are looking for does not exist. Return to Luminary Business Solutions home.',
  },
  gizlilik: {
    title: 'Privacy Policy | Luminary Business Solutions',
    description: 'Personal data processing under KVKK, contact form and information assistant data transfer.',
  },
  cerezler: {
    title: 'Cookie Policy | Luminary Business Solutions',
    description: 'Cookies used on the website, analytics consent and preference management.',
  },
  en: {
    title: 'English | Luminary Business Solutions',
    description: 'ERP consulting and ProSoft products — SAP Business One, Logo, Istanbul-based since 2008.',
    ogImage: '/images/cta002.jpg',
  },
};
